import type {InitParamsWDto} from '@cohort/wallet-schemas/init';

export type ShopifyIntegrationConfig = {
  type: 'shopify';
  appPath: string;
  loginPath: string;
  shopUrl: string;
};

export function initShopifyConfig(config: InitParamsWDto): ShopifyIntegrationConfig {
  if (
    config.integrationType &&
    config.integrationType === 'shopify' &&
    config.shopifyShopUrl &&
    config.shopifyAppPath &&
    config.shopifyLoginPath
  ) {
    return {
      type: 'shopify',
      appPath: config.shopifyAppPath,
      loginPath: config.shopifyLoginPath,
      shopUrl: config.shopifyShopUrl,
    };
  }
  throw new Error('Preconditions failed for shopify integration');
}
